import { z } from 'zod';

/**
 * プロダクト一覧の絞り込みチップ。
 *
 * - public / restricted / internal: PUBLISHED かつ当該 publishScope のプロダクト
 * - all: PUBLISHED かつ publishScope ∈ {public, restricted, internal}
 *   （非公開 scope=NONE は完全除外）
 * - in-development: publishStatus=IN_DEVELOPMENT（開発中）。公開範囲ではなく
 *   ステータスによる絞り込みで、上記 PUBLISHED 母集団とは別軸。
 *
 * 非公開(NONE)・公開終了(UNPUBLISHED)のチップは存在しない。
 */
const ProductPublishScopeFilterSchema = z.enum(['all', 'public', 'restricted', 'internal', 'in-development']);
export type ProductPublishScopeFilter = z.infer<typeof ProductPublishScopeFilterSchema>;
export const ProductTableFilterSchema = z.object({
  freeText: z.string().optional(),
  publishScope: ProductPublishScopeFilterSchema.catch('all').default('all'),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});